<nb-card class="import-wizard" [class.import-wizard--topup]="flowStep === 'topup'">
  <nb-card-header>
    <div class="header-content">
      <div class="title-container">
        <h4 class="import-title">
          {{ flowStep === 'topup' ? 'Top up wallet' : getUploadState(currentUpload).isSaved || getUploadState(currentUpload).isStopped ? 'Import Completed' : 'Import Data' }}
        </h4>
        @if (flowStep !== 'topup') {
        <div class="subtitle">
          {{ registrationsDataSourceCollection?.registrationsDataSources[registrationsDataSourceCollection?.selectedIndex].title }}
        </div>
        }
      </div>
      <button class="close-btn" nbButton ghost (click)="closeAndCleanupCompletely()" type="button">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <!-- Tab navigation -->
    @if (flowStep !== 'topup') {
    <div class="tabs-container">
      <ul class="tab-list">
        <li class="tab-item" [ngClass]="{ active: activeTab === TabView.IMPORT_WIZARD }" (click)="switchTab(TabView.IMPORT_WIZARD)">
          <nb-icon icon="file-add-outline" pack="eva"></nb-icon>
          Import New Data
        </li>
        <li class="tab-item" [ngClass]="{ active: activeTab === TabView.UPLOAD_HISTORY }" (click)="switchTab(TabView.UPLOAD_HISTORY)">
          <nb-icon icon="clock-outline" pack="eva"></nb-icon>
          View Import History
        </li>
        <!-- *ngIf="isUploadInProgressState(currentUpload)" -->
        <li class="tab-item" [ngClass]="{ active: activeTab === TabView.UPLOAD_PROGRESS }" (click)="switchTab(TabView.UPLOAD_PROGRESS)">
          <nb-icon icon="activity-outline" pack="eva"></nb-icon>
          Upload Details
        </li>
      </ul>
    </div>
    }
    <!-- Import Wizard -->
    @if (activeTab === TabView.IMPORT_WIZARD) {
    <div class="tab-content-wrapper">
      <!-- Steps indicator - only show if not in progress -->
      <div *ngIf="!getUploadState(currentUpload).isInProgress && flowStep !== 'topup'" class="steps-indicator">
        @if (isMemberImport()) {
        <div class="step" [ngClass]="{ active: currentStep >= 1 }">
          <div class="step-number">1</div>
          <div class="step-name">Parent</div>
        </div>
        <div class="step-connector"></div>
        }
        <div class="step" [ngClass]="{ active: currentStep >= fileStep() }">
          <div class="step-number">{{ isMemberImport() ? 2 : 1 }}</div>
          <div class="step-name">Select File</div>
        </div>
        <div class="step-connector"></div>
        <div class="step" [ngClass]="{ active: currentStep >= mapStep() }">
          <div class="step-number">{{ isMemberImport() ? 3 : 2 }}</div>
          <div class="step-name">Map Columns</div>
        </div>
        <div class="step-connector"></div>
        <div class="step" [ngClass]="{ active: currentStep >= reviewStep() }">
          <div class="step-number">{{ isMemberImport() ? 4 : 3 }}</div>
          <div class="step-name">Review & Import</div>
        </div>
      </div>

      <!-- Member import: pick the group parent before the file -->
      @if (isMemberImport() && currentStep === 1 && !getUploadState(currentUpload).isInProgress) {
      <div class="step-content">
        <div class="content-container">
          @if (missingParentForm()) {
          <h5 class="section-title">Group form is required</h5>
          <p class="text-danger">This member persona is not linked to a parent group form, so members cannot be imported.</p>
          } @else {
          <h5 class="section-title">Select parent registration</h5>
          <p class="section-description">Choose the exhibitor or group these members will be added to.</p>

          <input class="form-control tw-mb-3" type="search" placeholder="Search by name or email" [value]="parentSearchTerm()" (input)="onParentSearchInput($event)" />

          @if (parentSearchLoading()) {
          <p class="section-description">Searching…</p>
          }
          @if (parentSearchError()) {
          <p class="text-danger">{{ parentSearchError() }}</p>
          }

          <div
            class="tw-flex tw-h-64 tw-flex-col tw-gap-2 tw-overflow-y-auto"
            infiniteScroll
            [scrollWindow]="false"
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="150"
            [immediateCheck]="true"
            [infiniteScrollDisabled]="parentInfiniteScrollDisabled()"
            (scrolled)="onParentListScroll()"
            (scroll)="onParentListNativeScroll($event)"
          >
            @for (parent of parentResults(); track parent.id) {
            <button
              type="button"
              (click)="selectParent(parent)"
              class="tw-text-left tw-rounded tw-border tw-bg-white tw-p-3"
              [class.tw-border-blue-600]="selectedParent()?.id === parent.id"
              [class.tw-border-gray-200]="selectedParent()?.id !== parent.id"
            >
              <div class="tw-font-medium">{{ parentDisplayName(parent) }}</div>
              <div class="tw-text-sm tw-text-gray-600">{{ parentDisplaySubtitle(parent) }}</div>
            </button>
            }
            @if (parentSearchLoadingMore()) {
            <p class="section-description tw-m-0 tw-py-2">Loading more…</p>
            }
          </div>
          @if (!parentSearchLoading() && parentResults().length === 0) {
          <p class="section-description">No parent registrations found.</p>
          }

          @if (selectedParent(); as parent) {
          <p class="tw-mt-3 tw-font-medium">Selected: {{ parentDisplayName(parent) }} · {{ parentDisplaySubtitle(parent) }}</p>
          }
          }
        </div>
      </div>
      }

      <!-- Step: Upload File -->
      <div *ngIf="currentStep === fileStep() && !getUploadState(currentUpload).isInProgress" class="step-content">
        <div class="content-container">
          <h5 class="section-title">Upload your data file</h5>
          <p class="section-description">Upload a file containing your attendee data to begin the import process.</p>

          <div
            class="file-input-wrapper"
            (click)="fileInput.click()"
            [ngClass]="{
              'has-file': file,
              dragging: isDragging,
              'has-error': fileForm.get('fileInput')?.hasError('invalidFileType')
            }"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
          >
            <input #fileInput type="file" [accept]="supportedFormats" style="display: none" (change)="onFileChange($any($event.target).files)" (click)="$event.stopPropagation()" />

            <div class="upload-content" *ngIf="!file">
              <nb-icon icon="upload-outline" pack="eva"></nb-icon>
              <span class="upload-text"><strong>Choose a file</strong> or drag it here</span>
              <small>Only .csv files are supported</small>
              <div class="text-danger" *ngIf="fileForm.get('fileInput')?.hasError('invalidFileType')">Only .csv files are supported. Please try again.</div>
            </div>

            <div class="file-details" *ngIf="file">
              <div class="file-info">
                <nb-icon [icon]="getFileIcon()" pack="eva"></nb-icon>
                <div class="file-metadata">
                  <div class="file-name">{{ file.name }}</div>
                  <div class="file-size">{{ formatFileSize(file.size) }}</div>
                </div>
              </div>
              <button nbButton ghost status="danger" size="small" class="remove-btn" (click)="removeFile($event)" type="button">
                <nb-icon icon="close-outline" pack="eva"></nb-icon>
              </button>
            </div>
          </div>

          <!-- Template download option (moved to bottom) -->
          <div class="template-section">
            <p class="section-description">
              Don't have a template?
              <button nbButton outline size="small" status="primary" (click)="downloadTemplate()" type="button">
                <mat-icon class="material-icons">download</mat-icon> Download Template
              </button>
            </p>
          </div>
          <div *ngIf="fileRows.length === 0 && fileForm.valid" class="d-flex justify-content-start gap-2 align-items-center">
            <nb-icon icon="alert-triangle-outline" pack="eva" class="mr-2" status="warning"></nb-icon>
            <p class="text-danger m-0">Please Upload a file with at least 1 record to proceed.</p>
          </div>
          <div *ngIf="fileRows.length > 0 && isDuplicateHeaders" class="d-flex justify-content-start gap-2 align-items-center">
            <nb-icon icon="alert-triangle-outline" pack="eva" class="mr-2" status="warning"></nb-icon>
            <p class="text-danger m-0">Duplicate header found!</p>
          </div>
          <!-- Preview of loaded data if file is selected -->
          <div *ngIf="fileRows.length > 0 && !isDuplicateHeaders" class="data-preview-section">
            <h5 class="section-title">Data Preview</h5>
            <p class="section-description">First few rows from your file:</p>

            <div class="preview-container">
              <div class="table-container">
                <table class="preview-table">
                  <thead>
                    <tr>
                      <th *ngFor="let column of fileColumns" [title]="column">{{ column }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td *ngFor="let column of fileColumns" [title]="fileRows[0][column]">{{ fileRows[0][column] }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Import Started message - only show if in progress -->
      <div *ngIf="getUploadState(currentUpload).isInProgress" class="step-content">
        <div class="content-container">
          <div class="import-success">
            <div class="success-icon">
              <nb-icon icon="checkmark-circle-2-outline" pack="eva" status="success"></nb-icon>
            </div>
            <h5 class="section-title">Import Started</h5>
            <p class="section-description">Your data is being processed. You will receive an email with the results once the import is complete.</p>
            <button nbButton outline status="primary" (click)="uploadAnotherFile(currentUpload?.id)" type="button">
              <nb-icon icon="refresh-outline" pack="eva" class="mr-2"></nb-icon>
              Upload another file
            </button>
          </div>
        </div>
      </div>

      <!-- Step 2: Map Columns -->
      <div *ngIf="currentStep === mapStep() && !getUploadState(currentUpload).isInProgress" class="step-content">
        <div class="content-container">
          <h5 class="section-title">Map Your Columns</h5>
          <p class="section-description">Match system fields with columns from your file.</p>

          <div class="mapping-container">
            <div class="mapping-header">
              <div class="source-header">System Field</div>
              <div class="target-header">Your Column</div>
            </div>

            <form [formGroup]="mappingForm" class="mapping-form">
              <div class="mapping-row" *ngFor="let targetColumn of personaColumns">
                <div class="source-column">
                  <div class="column-name">
                    {{ targetColumn.header }}
                    <span class="required-badge" *ngIf="targetColumn.isRequired">Required</span>
                  </div>
                </div>
                <div class="map-arrow">
                  <nb-icon icon="arrow-right-outline" pack="eva"></nb-icon>
                </div>
                <div class="target-column">
                  <select class="form-select" [formControl]="safelyGetControl(targetColumn.field)" (change)="updateMapping($event.target.value, targetColumn.field)">
                    <option value="">-- Skip this field --</option>
                    <option
                      *ngFor="let source of getAvailableSourceColumns(targetColumn.field)"
                      [value]="source"
                      [selected]="source === safelyGetControl(targetColumn.field).value"
                    >
                      {{ source }}
                    </option>
                  </select>
                  <div class="text-danger" *ngIf="targetColumn.isRequired && !getMappedSourceColumn(targetColumn.field)">This field is required</div>
                </div>
              </div>
            </form>

            <div class="mapping-tips">
              <div class="tip-icon">
                <nb-icon icon="info-outline" pack="eva" status="info"></nb-icon>
              </div>
              <div class="tip-content"><strong>Tip:</strong> Map at least the required fields. Unmapped fields will be left empty.</div>
            </div>
            <div *ngIf="isNextButtonDisabled()" class="d-flex justify-content-center text-danger tip-content"><strong>Error:</strong> please map all required fields.</div>
          </div>
        </div>
      </div>

      <!-- Step 3: Review & Import -->
      @if (flowStep === 'topup') {
      <app-billing-wallet-top-up-modal
        [embedded]="true"
        [active]="true"
        [initialCustomAmount]="suggestedTopUpAmount()"
        [paymentMethods]="paymentMethods"
        (topUpSuccess)="onWalletTopUpSuccess($event)"
        (cancelRequested)="backFromTopUp()"
      ></app-billing-wallet-top-up-modal>
      }
      <div *ngIf="currentStep === reviewStep() && !getUploadState(currentUpload).isInProgress && flowStep === 'review'" class="step-content">
        <div class="content-container">
          <h5 class="section-title">Review & Import</h5>
          <p class="section-description">Review your import details before finalizing.</p>

          <div class="import-summary">
            <div class="summary-card">
              <div class="summary-icon">
                <nb-icon icon="people-outline" pack="eva" status="primary"></nb-icon>
              </div>
              <div class="summary-content">
                <div class="summary-title">Records to Import</div>
                <div class="summary-value">{{ mappedData.length }}</div>
              </div>
            </div>

            <div class="summary-card">
              <div class="summary-icon">
                <nb-icon icon="grid-outline" pack="eva" status="primary"></nb-icon>
              </div>
              <div class="summary-content">
                <div class="summary-title">Mapped Fields</div>
                <div class="summary-value">{{ getMappedColumnsCount() }}</div>
              </div>
            </div>
          </div>
          @if (isMemberImport() && selectedParent(); as parent) {
          <div class="options-section tw-bg-gray-100">
            <h6 class="subsection-title">Parent</h6>
            <p class="tw-m-0">{{ parentDisplayName(parent) }}</p>
            <p class="tw-m-0 tw-text-sm tw-text-gray-600">{{ parentDisplaySubtitle(parent) }}</p>
          </div>
          } @if (!isMemberImport() && enable_communication) {
          <div class="options-section tw-bg-gray-100">
            <h6 class="subsection-title">Attendee communication</h6>
            <div class="option-item tw-w-full tw-flex tw-flex-col tw-gap-2">
              <nb-checkbox [formControl]="confirmationForm.get('sendConfirmationEmail')" (checkedChange)="setCheckboxValue($event, 'sendConfirmationEmail')">
                Send confirmation emails
              </nb-checkbox>
              @if (canSendPhoneConfirmations) {
              <nb-checkbox [formControl]="confirmationForm.get('sendWhatsappConfirmation')" (checkedChange)="setCheckboxValue($event, 'sendWhatsappConfirmation')">
                Send WhatsApp confirmation messages <span class="tw-text-sm tw-text-gray-600">({{ whatsappPrice }}$ Per message)</span>
              </nb-checkbox>
              <nb-checkbox [formControl]="confirmationForm.get('sendSmsConfirmation')" (checkedChange)="setCheckboxValue($event, 'sendSmsConfirmation')">
                Send SMS confirmation messages <span class="tw-text-sm tw-text-gray-600">({{ smsPrice }}$ Per message)</span>
              </nb-checkbox>
              }
            </div>
          </div>
          } @if (isSuperAdmin) {
          <div class="options-section tw-bg-gray-100">
            <h6 class="subsection-title">Admin options</h6>
            <div class="option-item tw-w-full tw-flex tw-flex-col tw-gap-2">
              <nb-checkbox [formControl]="confirmationForm.get('bypassEmailValidation')" (checkedChange)="setCheckboxValue($event, 'bypassEmailValidation')">
                Bypass email validation
              </nb-checkbox>
            </div>
          </div>
          } @if (!isMemberImport() && canSendPhoneConfirmations) {
          <div class="tw-flex tw-min-h-11 tw-items-center tw-mb-4">
            @if (enable_communication && communicationCostUsd() > 0) { @if (loadingBalance) {
            <p class="tw-text-base tw-leading-relaxed tw-text-gray-500 tw-px-4">Checking wallet balance…</p>
            } @else if (!loadingBalance && !insufficientBalance){
            <div class="tw-px-4 tw-flex tw-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <g clip-path="url(#clip0_42374_73882)">
                  <path
                    d="M7 0.4375C8.73985 0.439537 10.4074 1.13203 11.6377 2.3623C12.868 3.59258 13.5605 5.26015 13.5625 7L13.5576 7.24316C13.5127 8.45588 13.132 9.63383 12.4561 10.6455C11.7351 11.7246 10.7107 12.5658 9.51172 13.0625C8.31259 13.5592 6.99272 13.6897 5.71973 13.4365C4.44673 13.1833 3.27716 12.5584 2.35938 11.6406C1.44159 10.7228 0.816692 9.55327 0.563477 8.28027C0.310269 7.00728 0.440804 5.68741 0.9375 4.48828C1.43422 3.28934 2.27543 2.26495 3.35449 1.54395C4.36617 0.867985 5.54412 0.487341 6.75684 0.442383L7 0.4375ZM6.65039 2.3623C6.25606 2.3623 5.87756 2.51913 5.59863 2.79785C5.31976 3.07672 5.16221 3.45524 5.16211 3.84961C5.16211 4.14381 5.24964 4.43214 5.41309 4.67676C5.54964 4.88106 5.73468 5.04716 5.9502 5.16211H5.59961C5.29807 5.16221 5.00913 5.28286 4.7959 5.49609C4.58268 5.70936 4.46294 5.99824 4.46289 6.2998C4.46289 6.60149 4.58258 6.89117 4.7959 7.10449C5.00911 7.3176 5.29816 7.4374 5.59961 7.4375H5.8623V8.66211H5.59961C5.29807 8.66221 5.00913 8.78286 4.7959 8.99609C4.58268 9.20936 4.46294 9.49824 4.46289 9.7998C4.46289 10.1015 4.58258 10.3912 4.7959 10.6045C5.00911 10.8176 5.29816 10.9374 5.59961 10.9375H8.40039C8.70184 10.9374 8.99089 10.8176 9.2041 10.6045C9.41742 10.3912 9.53711 10.1015 9.53711 9.7998C9.53706 9.49824 9.41732 9.20936 9.2041 8.99609C8.99087 8.78286 8.70193 8.66221 8.40039 8.66211H8.1377V6.2998C8.13764 5.99838 8.01772 5.70933 7.80469 5.49609C7.6579 5.34931 7.47439 5.24792 7.27637 5.19824C7.43356 5.12521 7.5783 5.02521 7.70215 4.90137C7.90989 4.69347 8.05197 4.42887 8.10938 4.14062C8.16677 3.85208 8.137 3.55208 8.02441 3.28027C7.91183 3.00868 7.721 2.77665 7.47656 2.61328C7.23205 2.4499 6.94445 2.36238 6.65039 2.3623Z"
                    fill="#1C64F2"
                    stroke="#1C64F2"
                    stroke-width="0.875"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_42374_73882">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p class="tw-w-full tw-rounded-lg tw-font-normal tw-px-2 tw-py-3">
                Total cost: <span class="tw-font-semibold">{{ requiredAmountUsd | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</span> for {{ mappedData.length }} selected
                recipient@if (mappedData.length !== 1) {s}.
              </p>
            </div>
            } @else if (insufficientBalance) {
            <div class="tw-w-full tw-rounded-lg tw-border tw-border-amber-200 tw-bg-amber-50 tw-px-4 tw-py-3">
              <div class="tw-flex tw-flex-col tw-gap-2">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <svg class="tw-shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path
                      d="M2.99882 19H16.9921C19.295 19 20.7426 16.5 19.6021 14.5435L12.5835 2.5C11.443 0.5 8.54787 0.5 7.40735 2.5L0.388796 14.5435C-0.729787 16.5217 0.695858 19 2.99882 19ZM10.0174 16.3261C9.40326 16.3261 8.8988 15.8261 8.8988 15.2174C8.8988 14.6087 9.40326 14.1087 10.0174 14.1087C10.6315 14.1087 11.136 14.6087 11.114 15.2391C11.136 15.8261 10.6096 16.3261 10.0174 16.3261ZM9.73225 6.32609C10.2586 6.19565 10.807 6.45652 11.0263 6.95652C11.0921 7.13043 11.136 7.30435 11.136 7.5C11.114 8.04348 11.0702 8.6087 11.0263 9.15217C10.9824 10 10.9166 10.8696 10.8728 11.7174C10.8508 12 10.8508 12.2391 10.8508 12.5217C10.8289 12.9783 10.478 13.3261 10.0174 13.3261C9.55679 13.3261 9.20586 13 9.18393 12.5435C9.11813 11.2174 9.0304 9.8913 8.9646 8.56522C8.94266 8.21739 8.92073 7.86957 8.8988 7.5C8.87686 6.95652 9.20586 6.47826 9.73225 6.32609Z"
                      fill="#E3A008"
                    />
                  </svg>
                  <p class="tw-m-0 tw-text-sm tw-leading-5 tw-text-gray-700">
                    <span class="tw-font-medium">Insufficient balance.</span>
                    <span class="tw-font-normal">
                      <span class="tw-font-semibold">Total: {{ requiredAmountUsd | currency : 'USD' : 'symbol-narrow' : '1.2-2' }} for {{ mappedData.length }} </span> selected
                      recipient@if (mappedData.length !== 1) {s}. Please add
                    </span>
                    <span class="tw-font-semibold">{{ balanceShortfallUsd() | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</span>
                    <span class="tw-font-normal"> to import and send confirmations.</span>
                  </p>
                </div>
              </div>
            </div>
            } }
          </div>
          }
          <div class="mapping-summary">
            <h6 class="subsection-title">Column Mapping Summary</h6>
            <div class="mapping-list">
              <div *ngIf="hasNoMappedColumns()" class="no-mappings">No columns have been mapped. Please go back and map at least one column.</div>
              <div class="mapping-header" style="font-weight: 600; color: #222b45; display: flex; gap: 1rem">
                <div style="flex: 1">System Field</div>
                <div style="flex: 1">Your Column</div>
              </div>
              <div *ngFor="let mapping of columnsMap" class="mapping-item">
                <ng-container *ngIf="mapping.targetColumn">
                  <div class="target">{{ getTargetColumnHeader(mapping.targetColumn) }}</div>
                  <div class="arrow">
                    <nb-icon icon="arrow-right-outline" pack="eva"></nb-icon>
                  </div>
                  <div class="source">{{ mapping.sourceColumn || '-- Skipped --' }}</div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (flowStep !== 'topup') {
      <div class="wizard-actions d-flex justify-content-between">
        <!-- Back button (not shown on first step or after import) -->
        <div class="d-flex">
          @if (activeTab === TabView.IMPORT_WIZARD && currentStep > 1) {
          <button
            type="button"
            class="tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-5 tw-py-2.5 tw-font-medium tw-text-gray-800 tw-shadow-none hover:tw-bg-gray-50 disabled:tw-opacity-50"
            (click)="goToPreviousStep()"
          >
            Back
          </button>
          }
          <!-- Cancel button (only on first step) -->
          @if(getUploadState(currentUpload).isInProgress){
          <button nbButton outline status="basic" (click)="closeAndCleanupCompletely()" type="button">Cancel</button>
          }
        </div>

        <div class="d-flex">
          <!-- Next button (steps 1-2) -->
          @if (currentStep < reviewStep()) {
          <button nbButton status="primary" [disabled]="isNextButtonDisabled()" (click)="onNextButtonClick()" type="button">
            Next
            <mat-icon class="material-icons ml-2">navigate_next</mat-icon>
          </button>
          }
          <!-- Import button (final step) -->
          @if (currentStep === reviewStep() && !getUploadState(currentUpload).isInProgress) {
          <button
            type="button"
            class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-px-5 tw-py-2.5 tw-font-medium tw-shadow-none !tw-bg-blue-600 !tw-text-white hover:!tw-bg-blue-700 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            (click)="upload()"
            [disabled]="!canImportProceed() || loadingBalance || loadingPaymentMethods || isImporting"
          >
            @if (!isImporting && !isImportTopUpAction()) {
            <nb-icon icon="save-outline" pack="eva" class="mr-2"></nb-icon>
            } @if (isImporting) {
            <nb-icon icon="loader-outline" pack="eva" class="mr-2 spin-icon"></nb-icon>
            } @if (isImporting) { Importing... } @else if (insufficientBalance && communicationCostUsd() > 0) {
            {{ loadingPaymentMethods ? 'Loading…' : 'Top up' }}
            } @else if (loadingBalance && communicationCostUsd() > 0) { Checking… } @else { Import Data }
          </button>
          }
        </div>
      </div>
      }
    </div>
    }
    <!-- Upload History Tab -->
    @if (activeTab === TabView.UPLOAD_HISTORY) {
    <div class="upload-history-content">
      <div class="content-container">
        <h5 class="section-title">Upload History</h5>
        <p class="section-description">View the status of your previous data imports.</p>

        <div *ngIf="!isLoadingMore && uploadHistory.length === 0" class="no-history">
          <nb-icon icon="folder-outline" pack="eva" status="basic"></nb-icon>
          <p>No uploads found for this persona</p>
        </div>

        <!-- Loading indicator -->
        <div *ngIf="isLoadingMore" class="position-sticky bottom-0 start-0 end-0 bg-white bg-opacity-90 p-3 text-center border-top">
          <div class="d-flex flex-column align-items-center justify-content-center gap-2">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <span>Loading page {{ current_page }}...</span>
          </div>
        </div>

        <!-- No data indicator -->
        <div *ngIf="!isLoadingMore && uploadHistory.length > 0" class="history-list position-relative" style="max-height: 600px; overflow-y: auto">
          <table class="history-table">
            <thead>
              <tr>
                <th class="import-column">Import</th>
                <th class="date-column">Date</th>
                <th class="status-column">Status</th>
                <th class="results-column">Results</th>
                <th class="actions-column">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let upload of uploadHistory" class="history-row">
                <td class="import-column" (click)="viewUploadDetails(upload)">{{ upload.status.recordCount || 0 }} Records</td>
                <td class="date-column" (click)="viewUploadDetails(upload)" [nbTooltip]="formatFullDate(upload.created_at)">
                  {{ formatDate(upload.created_at) }}
                </td>
                <td class="status-column" (click)="viewUploadDetails(upload)">
                  <span class="status-badge" [ngClass]="getUploadStatusInfo(upload).statusClass">
                    {{ getUploadStatusInfo(upload).statusLabel }}
                  </span>
                </td>
                <td class="results-column" (click)="viewUploadDetails(upload)">
                  <div class="count-labels">
                    <span *ngIf="upload.savedLinesCount > 0 && !getUploadState(upload).isInProgress"> {{ upload.savedLinesCount }} valid </span>
                    <span *ngIf="upload.invalidLinesCount > 0 && !getUploadState(upload).isInProgress"> {{ upload.invalidLinesCount }} invalid </span>
                    <span *ngIf="upload.savedLinesCount === 0 && upload.invalidLinesCount === 0 && getUploadState(upload).isInProgress"> Processing... </span>
                    <span *ngIf="upload.savedLinesCount === 0 && upload.invalidLinesCount === 0 && !getUploadState(upload).isInProgress"> No records processed </span>
                  </div>
                </td>
                <td class="actions-cell actions-column">
                  <!-- Show stop button for in-progress uploads -->
                  <button
                    *ngIf="getUploadState(upload).isInProgress"
                    nbButton
                    ghost
                    size="small"
                    status="danger"
                    nbTooltip="Stop this upload process"
                    title="Stop Upload"
                    (click)="stopUpload(upload.id, $event)"
                    [disabled]="upload.status.state === 'closed'"
                    type="button"
                  >
                    <nb-icon icon="stop-circle-outline" pack="eva"></nb-icon>
                  </button>

                  <!-- Download invalid records button - only if there are invalid records -->
                  <button
                    *ngIf="(getUploadState(upload).isSaved || getUploadState(upload).isStopped) && upload.invalidLinesCount > 0"
                    nbButton
                    ghost
                    size="small"
                    status="info"
                    nbTooltip="Download {{ upload.invalidLinesCount }} invalid records with error details"
                    title="Download Invalid Records"
                    (click)="downloadInvalidRecords(upload, $event)"
                    type="button"
                  >
                    <nb-icon icon="download-outline" pack="eva"></nb-icon>
                  </button>

                  <!-- Send emails button - only for completed uploads with valid records that didn't have emails sent -->
                  <button
                    *ngIf="getUploadState(upload).isSaved && !upload.send_email && upload.savedLinesCount > 0"
                    nbButton
                    ghost
                    size="small"
                    status="success"
                    nbTooltip="Send confirmation emails to {{ upload.savedLinesCount }} valid records"
                    title="Send Confirmation Emails"
                    (click)="sendConfirmationEmails(upload, $event)"
                    type="button"
                  >
                    <nb-icon icon="email-outline" pack="eva"></nb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination Controls -->
          <div class="d-flex justify-content-center align-items-center gap-3 mt-4 p-3 border-top">
            <button
              nbButton
              ghost
              status="basic"
              size="small"
              (click)="prevPage()"
              [disabled]="current_page === 1 || isLoadingMore"
              nbTooltip="Go to previous page"
              nbTooltipStatus="basic"
              nbTooltipPlacement="top"
              type="button"
              class="d-flex align-items-center justify-content-center gap-2 px-3 py-2 rounded-3 transition-all"
            >
              <nb-icon icon="chevron-left-outline" pack="eva" class="fs-5"></nb-icon>
            </button>

            <div class="d-flex align-items-center px-3 py-2">
              <span class="text-muted"> Page </span>
              <span class="fw-bold mx-1"> {{ current_page }} </span>
              <span class="text-muted"> of </span>
              <span class="fw-bold mx-1"> {{ totalPages }}</span>
            </div>

            <button
              nbButton
              ghost
              status="basic"
              size="small"
              (click)="nextPage()"
              [disabled]="current_page === totalPages || isLoadingMore"
              nbTooltip="Go to next page"
              nbTooltipStatus="basic"
              nbTooltipPlacement="top"
              type="button"
              class="d-flex align-items-center justify-content-center gap-2 px-3 py-2 rounded-3 transition-all"
            >
              <nb-icon icon="chevron-right-outline" pack="eva" class="fs-5"></nb-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="tab-actions">
        <button nbButton status="primary" (click)="switchTab(TabView.IMPORT_WIZARD)" type="button">
          <nb-icon icon="plus-outline" pack="eva" class="mr-2"></nb-icon>
          New Import
        </button>
      </div>
    </div>
    }
    <!-- Upload Progress Tab -->
    @if (activeTab === TabView.UPLOAD_PROGRESS) {
    <div class="upload-progress-content">
      <div class="content-container">
        <h5 class="section-title">Upload Details</h5>
        <p class="section-description">
          {{
            getUploadState(selectedUpload).isInProgress
              ? 'Your data is being processed. You can close this dialog and
          check back later.'
              : 'Upload information and results'
          }}
        </p>

        <div *ngIf="selectedUpload" class="progress-details">
          <div class="upload-info">
            <div class="info-item">
              <span class="label">Started:</span>
              <span class="value">{{ formatDate(selectedUpload.created_at) }}</span>
            </div>
            <div class="info-item">
              <span class="label">Status:</span>
              <span class="value status-badge" [ngClass]="getUploadStatusInfo(selectedUpload).statusClass">
                {{ getUploadStatusInfo(selectedUpload).statusLabel }}
              </span>
            </div>
            <div class="info-item">
              <span class="label">Form:</span>
              <span class="value">{{ registrationsDataSourceCollection?.registrationsDataSources[registrationsDataSourceCollection?.selectedIndex].title }}</span>
            </div>
            @if (isMemberImport() && selectedParent(); as parent) {
            <div class="info-item">
              <span class="label">Parent members:</span>
              <span class="value">{{ parent.childCount }}</span>
            </div>
            }
            <div class="info-item">
              <span class="label">Total Records:</span>
              <span class="value">{{ selectedUpload.status.recordCount || 0 }}</span>
            </div>
          </div>

          <div class="progress-section">
            <h6 class="subsection-title">Progress</h6>
            <div class="progress-container">
              <!-- Bootstrap progress bar -->
              <div class="progress position-relative">
                <!-- Percentage Text Centered in the Grey Background -->
                <span class="position-absolute w-100 text-center" style="z-index: 1"> {{ getUploadStatusInfo(selectedUpload).progress }}% </span>

                <!-- Actual Progress Bar -->
                <div
                  class="progress-bar"
                  role="progressbar"
                  [class.progress-bar-animated]="getUploadState(selectedUpload).isInProgress"
                  [class.progress-bar-striped]="getUploadState(selectedUpload).isInProgress"
                  [style.width.%]="getUploadStatusInfo(selectedUpload).progress"
                  [ngClass]="getUploadState(selectedUpload).isSaved ? 'bg-success' : 'bg-primary'"
                  [attr.aria-valuenow]="getUploadStatusInfo(selectedUpload).progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>

            <div class="progress-stats">
              <div class="stat-item">
                <span class="label">Records processed:</span>
                <span class="value">{{ (selectedUpload.savedLinesCount || 0) + (selectedUpload.invalidLinesCount || 0) }} / {{ selectedUpload.status.recordCount || 0 }}</span>
              </div>
              <div class="stat-item">
                <span class="label">Results:</span>
                <div class="count-labels">
                  <span *ngIf="selectedUpload.savedLinesCount > 0" class="count-badge success"> {{ selectedUpload.savedLinesCount }} valid </span>
                  <span *ngIf="selectedUpload.invalidLinesCount > 0" class="count-badge warning"> {{ selectedUpload.invalidLinesCount }} invalid </span>
                  <span *ngIf="selectedUpload.savedLinesCount === 0 && selectedUpload.invalidLinesCount === 0" class="no-counts"> No records processed </span>
                </div>
              </div>
            </div>
          </div>

          <div class="progress-message" *ngIf="getUploadState(selectedUpload).isInProgress && !isStoppedByUser">
            <nb-icon icon="info-outline" pack="eva" status="info"></nb-icon>
            <p>You can close this dialog and check back later by reopening the import tool. Your upload will continue processing in the background.</p>
          </div>
          @if (emailCheckForcedOn()) {
          <div class="alert alert-warning d-flex">
            <nb-icon icon="alert-triangle-outline" pack="eva" class="mr-2" status="warning"></nb-icon>
            <p class="m-0">Email validation stayed on. This account cannot skip it.</p>
          </div>
          }
          @if (isImportFailed(selectedUpload)) {
          <div class="alert alert-danger d-flex">
            <nb-icon icon="alert-triangle-outline" pack="eva" class="mr-2" status="danger"></nb-icon>
            <p class="m-0">The member import failed. Download invalid rows if any were reported.</p>
          </div>
          }
          <div class="alert alert-warning d-flex" *ngIf="(isStoppedByUser || getUploadState(selectedUpload).isStopped) && !isImportFailed(selectedUpload)">
            <nb-icon icon="info-outline" pack="eva" class="mr-2" status="info"></nb-icon>
            <p class="mb-0">You stopped the upload process.</p>
          </div>

          <div class="progress-message success-message" *ngIf="(getUploadState(selectedUpload).isSaved || getUploadState(selectedUpload).isStopped) && !isImportFailed(selectedUpload)">
            <nb-icon icon="checkmark-circle-outline" pack="eva" status="success"></nb-icon>
            <p>Upload completed on {{ formatDate(selectedUpload.status.save_end || selectedUpload.created_at) }}.</p>
          </div>

          <!-- Action buttons based on status -->
          <div class="upload-actions" *ngIf="selectedUpload">
            <!-- Stop button - only shown for in-progress uploads -->
            <button
              *ngIf="!(getUploadState(selectedUpload).isStopped || getUploadState(selectedUpload).isSaved) && !isStoppedByUser"
              nbButton
              outline
              status="danger"
              (click)="stopUpload(selectedUpload.id)"
              [disabled]="selectedUpload.status.state === 'closed'"
              type="button"
            >
              <nb-icon icon="stop-circle-outline" pack="eva" class="mr-2"></nb-icon>
              Stop Upload
            </button>

            <!-- Download invalid records button - only shown for completed uploads with invalid records -->
            <button *ngIf="hasInvalidRecords(selectedUpload)" nbButton outline status="info" (click)="downloadInvalidRecords(selectedUpload)" type="button">
              <nb-icon icon="download-outline" pack="eva" class="mr-2"></nb-icon>
              Download Invalid Records
            </button>
            <button
              *ngIf="shouldShowSendEmailButton(selectedUpload, isStoppedByUser)"
              nbButton
              outline
              status="success"
              (click)="sendConfirmationEmails(selectedUpload)"
              type="button"
            >
              <nb-icon icon="email-outline" pack="eva" class="mr-2"></nb-icon>
              Send Confirmation Emails
            </button>
          </div>
        </div>

        <div *ngIf="!selectedUpload" class="no-upload-progress">
          <nb-icon icon="alert-circle-outline" pack="eva" status="warning"></nb-icon>
          <p>No upload details found.</p>
        </div>
      </div>

      <div class="tab-actions">
        <button *ngIf="!isStoppedByUser && getUploadState(selectedUpload)?.isInProgress" nbButton status="basic" (click)="refreshUploadHistory()" type="button">
          <nb-icon icon="refresh-outline" pack="eva" class="mr-2"></nb-icon>
          Refresh Status
        </button>
        <button nbButton status="primary" (click)="switchTab(TabView.UPLOAD_HISTORY)" type="button">
          <nb-icon icon="list-outline" pack="eva" class="mr-2"></nb-icon>
          View All History
        </button>
        <button nbButton status="primary" (click)="switchTab(TabView.IMPORT_WIZARD)" type="button">
          <nb-icon icon="plus-outline" pack="eva" class="mr-2"></nb-icon>
          New Import
        </button>
      </div>
    </div>
    }
  </nb-card-body>
</nb-card>
